var map = {
	"./add.svg": 144,
	"./addSmall.svg": 434,
	"./close.svg": 10,
	"./height.svg": 50,
	"./next.svg": 330,
	"./open.svg": 95,
	"./prev.svg": 81,
	"./scroll.svg": 315,
	"./typeCheckbox.svg": 32,
	"./typeText.svg": 266,
	"./variants/close.svg": 106,
	"./variants/typeCheckbox (2).svg": 282,
	"./variants/typeCheckbox.svg": 896,
	"./variants/typeText (2).svg": 673,
	"./variants/typeText.svg": 968,
	"./variants/typeText2.svg": 284,
	"./width.svg": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;